export const DEFAULT_SKR04_CATEGORY_IDS = [
    1350, 1370, 2100, 2200, 2900, 4000, 4100, 4110, 4120, 4200, 4510, 4520,
    4560, 4570, 4700, 4730, 4770, 4820, 4830, 4840, 4850, 4860, 4960, 5100,
    5200, 5600, 5610, 5660, 5700, 5730, 5770, 5800, 5820, 5840, 5900, 5960,
    6000, 6010, 6020, 6030, 6040, 6050, 6060, 6070, 6080, 6090, 6110, 6120,
    6130, 6140, 6150, 6160, 6170, 6200, 6220, 6250, 6260, 6280, 6300, 6310,
    6320, 6330, 6340, 6350, 6390, 6400, 6410, 6420, 6430, 6440, 6450, 6460,
    6470, 6490, 6500, 6520, 6530, 6540, 6550, 6560, 6570, 6580, 6590, 6600,
    6610, 6620, 6630, 6650, 6660, 6690, 6700, 6710, 6740, 6760, 6770, 6780,
    6790, 6800, 6810, 6820, 6830, 6840, 6850, 6860, 6880, 6890, 6900, 6910,
    6920, 6930, 6960, 7100, 7200, 7210, 7250, 7300, 7310, 7320, 7330, 7340,
    7350, 7360, 7390, 7560, 4300, 4400, 4410, 4610, 4620, 4630, 4640, 4650,
    4660, 4670, 4680, 4710, 4720, 4750, 4760, 4780, 4790, 5110, 5130, 5300,
    5400, 5710, 5720, 5750, 5760, 5780, 5790, 5920, 6670, 6680, 5000, 5010,
    5020, 5030, 5040, 5050, 5060, 5070, 5080, 5090, 7500,
]

export const SKR04_CATEGORIES = {
    '1350': {
        id: '1350',
        label: 'Kautionen',
        description: 'Gezahlte Kautionen z. B. für Büroräume',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '1370': {
        id: '1370',
        label: 'Durchlaufende Posten',
        description:
            'Einnahmen, die weitergereicht werden und somit nicht ins Gewicht fallen',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
            {
                name: 'NICHT_STEUERBAR_REVENUE',
                id: 22,
                description: 'z.B. Durchlaufende Posten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE', 'EXPENSE'],
    },
    '1371': {
        id: '1371',
        label: 'Durchlaufende Posten',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '1433': {
        id: '1433',
        label: 'Einfuhrumsatzsteuer',
        description:
            'Von der deutschen Zollverwaltung erhobene Einfuhrumsatzsteuer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2100': {
        id: '2100',
        label: 'Privatentnahmen allgemein',
        description:
            'z. B. Entnahmen von Bargeld aus der Firmenkasse oder Bank für private Zwecke',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2101': {
        id: '2101',
        label: 'Privatentnahmen allgemein (nur Einzelunternehmen)',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2200': {
        id: '2200',
        label: 'Sonderausgaben beschränkt abzugsfähig',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2201': {
        id: '2201',
        label: 'Sonderausgaben beschränkt abzugsfähig (nur Einzelunternehmen)',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '2900': {
        id: '2900',
        label: 'Gezeichnetes Kapital',
        description:
            'Kapitaleinzahlungen, z. B. die Stammkapitaleinzahlung bei der GmbH',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_REVENUE',
                id: 22,
                description: 'z.B. Durchlaufende Posten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4000': {
        id: '4000',
        label: 'Umsatzerlöse',
        description: 'Einnahmen aus dem Verkauf von Waren und Dienstleistungen',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4001': {
        id: '4001',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4002': {
        id: '4002',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4003': {
        id: '4003',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4004': {
        id: '4004',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4005': {
        id: '4005',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4006': {
        id: '4006',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4007': {
        id: '4007',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4008': {
        id: '4008',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4009': {
        id: '4009',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4010': {
        id: '4010',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4011': {
        id: '4011',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4012': {
        id: '4012',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4013': {
        id: '4013',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4014': {
        id: '4014',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4015': {
        id: '4015',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4016': {
        id: '4016',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4017': {
        id: '4017',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4018': {
        id: '4018',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4019': {
        id: '4019',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4020': {
        id: '4020',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4021': {
        id: '4021',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4022': {
        id: '4022',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4023': {
        id: '4023',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4024': {
        id: '4024',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4025': {
        id: '4025',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4026': {
        id: '4026',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4027': {
        id: '4027',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4028': {
        id: '4028',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4029': {
        id: '4029',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4030': {
        id: '4030',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4031': {
        id: '4031',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4032': {
        id: '4032',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4033': {
        id: '4033',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4034': {
        id: '4034',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4035': {
        id: '4035',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4036': {
        id: '4036',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4037': {
        id: '4037',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4038': {
        id: '4038',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4039': {
        id: '4039',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4040': {
        id: '4040',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4041': {
        id: '4041',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4042': {
        id: '4042',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4043': {
        id: '4043',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4044': {
        id: '4044',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4045': {
        id: '4045',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4046': {
        id: '4046',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4047': {
        id: '4047',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4048': {
        id: '4048',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4049': {
        id: '4049',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4050': {
        id: '4050',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4051': {
        id: '4051',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4052': {
        id: '4052',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4053': {
        id: '4053',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4054': {
        id: '4054',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4055': {
        id: '4055',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4056': {
        id: '4056',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4057': {
        id: '4057',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4058': {
        id: '4058',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4059': {
        id: '4059',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4060': {
        id: '4060',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4061': {
        id: '4061',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4062': {
        id: '4062',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4063': {
        id: '4063',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4064': {
        id: '4064',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4065': {
        id: '4065',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4066': {
        id: '4066',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4067': {
        id: '4067',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4068': {
        id: '4068',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4069': {
        id: '4069',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4070': {
        id: '4070',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4071': {
        id: '4071',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4072': {
        id: '4072',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4073': {
        id: '4073',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4074': {
        id: '4074',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4075': {
        id: '4075',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4076': {
        id: '4076',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4077': {
        id: '4077',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4078': {
        id: '4078',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4079': {
        id: '4079',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4080': {
        id: '4080',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4081': {
        id: '4081',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4082': {
        id: '4082',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4083': {
        id: '4083',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4084': {
        id: '4084',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4085': {
        id: '4085',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4086': {
        id: '4086',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4087': {
        id: '4087',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4088': {
        id: '4088',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4089': {
        id: '4089',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4090': {
        id: '4090',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4091': {
        id: '4091',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4092': {
        id: '4092',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4093': {
        id: '4093',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4094': {
        id: '4094',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4095': {
        id: '4095',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4096': {
        id: '4096',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4097': {
        id: '4097',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4098': {
        id: '4098',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4099': {
        id: '4099',
        label: 'Umsatzerlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4100': {
        id: '4100',
        label: 'Steuerfreie Umsätze § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4101': {
        id: '4101',
        label: 'Steuerfreie Umsätze § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4102': {
        id: '4102',
        label: 'Steuerfreie Umsätze § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4103': {
        id: '4103',
        label: 'Steuerfreie Umsätze § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4104': {
        id: '4104',
        label: 'Steuerfreie Umsätze § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4110': {
        id: '4110',
        label: 'Sonstige steuerfreie Umsätze Inland',
        description: 'Steuerfreie Einnahmen die unter den § 4 UStG fallen',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4120': {
        id: '4120',
        label: 'Steuerfreie Erlöse Drittland',
        description: '',
        allowedTaxRules: [
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4125': {
        id: '4125',
        label: 'steuerfreie EU Erlöse',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4136': {
        id: '4136',
        label: 'Umsätze nach §§ 25 und 25a UStG 19 %  USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4200': {
        id: '4200',
        label: 'Erlöse',
        description: 'Einnahmen aus dem Verkauf von Waren und Dienstleistungen',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'AUSFUHREN',
                id: 2,
                description: 'Ausfuhren ins Drittland',
                taxRates: ['ZERO'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4300': {
        id: '4300',
        label: 'Erlöse 7 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen mit 7 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4301': {
        id: '4301',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4302': {
        id: '4302',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4303': {
        id: '4303',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4304': {
        id: '4304',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4305': {
        id: '4305',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4306': {
        id: '4306',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4307': {
        id: '4307',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4308': {
        id: '4308',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4309': {
        id: '4309',
        label: 'Erlöse 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4334': {
        id: '4334',
        label: 'Erlöse 7 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen mit 7 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4336': {
        id: '4336',
        label: 'Erlöse aus im anderen EU-Land steuerpflichtigen sonstigen Leistungen, für die der Leistungsempfänger die Umsatzsteuer schuldet',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_1_USTG',
                id: 21,
                description:
                    'z.B. Dienstleistungen an Unternehmer in anderen EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4337': {
        id: '4337',
        label: 'Erlöse aus Leistungen nach § 13 b UStG',
        description: 'Einnahmen für Umsätze nach § 13b z. B. bei Bauleistungen',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_1',
                id: 5,
                description: 'Reverse Charge gem. §13b UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4338': {
        id: '4338',
        label: 'Nicht steuerbare Umsätze Drittland',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4400': {
        id: '4400',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4401': {
        id: '4401',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4402': {
        id: '4402',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4403': {
        id: '4403',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4404': {
        id: '4404',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4405': {
        id: '4405',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4406': {
        id: '4406',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4407': {
        id: '4407',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4408': {
        id: '4408',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4409': {
        id: '4409',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4410': {
        id: '4410',
        label: 'Erlöse 19 % USt',
        description:
            'Einnahmen aus dem Verkauf von Waren und Dienstleistungen 19 %',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4510': {
        id: '4510',
        label: 'Erlöse Abfallverwertung',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4520': {
        id: '4520',
        label: 'Erlöse Leergut',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4560': {
        id: '4560',
        label: 'Provisionsumsätze',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4564': {
        id: '4564',
        label: 'Provisionsumsätze steuerfrei § 4 Nr. 8ff',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4566': {
        id: '4566',
        label: 'Provisionsumsätze 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4569': {
        id: '4569',
        label: 'Provisionsumsätze 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4570': {
        id: '4570',
        label: 'Provisionen sonstige Erträge',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4574': {
        id: '4574',
        label: 'Sonstige Erträge aus Provisionen, Lizenzen und Patenten, steuerfrei § 4 Nr. 8 ff. UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4576': {
        id: '4576',
        label: 'sonstige Erträge aus Provisionen Lizenzen und Patenten 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4579': {
        id: '4579',
        label: 'sonstige Erträge aus Provisionen Lizenzen und Patenten 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4610': {
        id: '4610',
        label: 'Entnahme durch den Unternehmer für Zwecke außerhalb des Unternehmens (Waren) 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4619': {
        id: '4619',
        label: 'Entnahmen durch den Unternehmen für Zwecke außerhalb des Unternehmens ohne USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4620': {
        id: '4620',
        label: 'Entnahmen durch den Unternehmen für Zwecke außerhalb des Unternehmens 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4630': {
        id: '4630',
        label: 'Verwendung von Gegenständen für Zwecke außerhalb des Unternehmens 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4639': {
        id: '4639',
        label: 'Verwendung von Gegenständen für Zwecke außerhalb des Unternehmens o. USt (KFZ Nutzung)',
        description: '',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_REVENUE',
                id: 22,
                description: 'z.B. Durchlaufende Posten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4640': {
        id: '4640',
        label: 'Verwendung von Gegenständen für Zwecke außerhalb des Unternehmens 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4645': {
        id: '4645',
        label: 'Verwendung von Gegenständen für Zwecke außerhalb des Unternehmens 19 % USt (KFZ Nutzung)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4646': {
        id: '4646',
        label: 'Verwendung von Gegenständen für Zwecke außerhalb des Unternehmens 19 % USt (Telefonnutzung)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4650': {
        id: '4650',
        label: 'Unentgeltliche Erbringung einer sonstigen Leistung 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4660': {
        id: '4660',
        label: 'Unentgeltliche Erbringung einer sonstigen Leistung 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4670': {
        id: '4670',
        label: 'Unentgeltliche Zuwendung von Waren 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4680': {
        id: '4680',
        label: 'Unentgeltliche Zuwendung von Waren 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4686': {
        id: '4686',
        label: 'Unentgeltliche Zuwendung von Gegenständen 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4700': {
        id: '4700',
        label: 'Erlösschmälerungen',
        description: 'z. B. Rabatte',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4701': {
        id: '4701',
        label: 'Erlösschmälerungen steuerfrei § 4 Nr. 8ff UStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4703': {
        id: '4703',
        label: 'Erlösschmälerungen für sonstige steuerfreie Umsätze ohne Vorsteuerabzug',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4704': {
        id: '4704',
        label: 'Erlösschmälerungen für sonstige steuerfreie Umsätze mit Vorsteuerabzug',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4710': {
        id: '4710',
        label: 'Erlösschmälerungen 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4720': {
        id: '4720',
        label: 'Erlösschmälerungen 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4730': {
        id: '4730',
        label: 'Gewährte Skonti',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4731': {
        id: '4731',
        label: 'Gewährte Skonti 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4736': {
        id: '4736',
        label: 'Gewährte Skonti 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4745': {
        id: '4745',
        label: 'Gewährte Skonti steuerpflichtige EU-Lieferungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4750': {
        id: '4750',
        label: 'Gewährte Boni 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4760': {
        id: '4760',
        label: 'Gewährte Boni 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4769': {
        id: '4769',
        label: 'Gewährte Boni',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4770': {
        id: '4770',
        label: 'Gewährte Rabatte',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4780': {
        id: '4780',
        label: 'Gewährte Rabatte 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4790': {
        id: '4790',
        label: 'Gewährte Rabatte 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4820': {
        id: '4820',
        label: 'andere aktivierte Eigenleistungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4830': {
        id: '4830',
        label: 'Sonstige betriebliche Erträge',
        description:
            'Einnahmen, die nicht den anderen Erlöskonten zugeordnet werden können',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4835': {
        id: '4835',
        label: 'Sonstige betriebl. Regelm. Erträge',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4836': {
        id: '4836',
        label: 'Sonstige Erträge betrieblich und regelmäßig 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4837': {
        id: '4837',
        label: 'Sonstige Erträge betriebsfremd und regelmäßig',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4839': {
        id: '4839',
        label: 'Sonstige Erträge unregelmäßig',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4840': {
        id: '4840',
        label: 'Erträge aus der Währungsumrechnung',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'NICHT_IM_INLAND_STEUERBAR',
                id: 17,
                description: 'außerhalb EU, z.B. Schweiz',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4841': {
        id: '4841',
        label: 'Sonst. Erträge betr. u. regelmäßig steuerfrei',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4845': {
        id: '4845',
        label: 'Erlöse aus Verkäufen Sachanlagevermögen 19 % USt (Bei Buchgewinn)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4849': {
        id: '4849',
        label: 'Erlöse Sachanlagenverkäufe Buchgewinn',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4850': {
        id: '4850',
        label: 'Erlöse aus Verkäufen immaterieller Vermögensgegenstände (bei Buchgewinn)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4855': {
        id: '4855',
        label: 'Abgänge Sachanlagen Restbuchwert bei BG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4857': {
        id: '4857',
        label: 'Abgänge Finanzanlagen Restbuchwert BG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4858': {
        id: '4858',
        label: 'Abgänge Finanzanlagen RBW z.T. Stf., BG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4860': {
        id: '4860',
        label: 'Grundstückserträge',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4862': {
        id: '4862',
        label: 'Erlöse aus Vermietung und Verpachtung 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4925': {
        id: '4925',
        label: 'Erträge aus abgeschriebenen Forderungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4941': {
        id: '4941',
        label: 'Sachbezüge 7 %  USt (Waren)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4945': {
        id: '4945',
        label: 'Sachbezüge 19 % USt (Waren)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4947': {
        id: '4947',
        label: 'Verrechnete sonstige Sachbezüge aus Kfz Gestellung 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4948': {
        id: '4948',
        label: 'Verrechnete sonstige Sachbezüge 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4960': {
        id: '4960',
        label: 'Periodenfremde Erträge (soweit nicht außerordentlich)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4975': {
        id: '4975',
        label: 'Investitionszuschüsse',
        description: 'z. B. Coronahilfen',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_TAX',
                id: 15,
                description:
                    'z.B. Umsatzsteuervorauszahlungen oder Umsatzsteuerrückerstattung',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4982': {
        id: '4982',
        label: 'Sonstige steuerfreie Betriebseinnahmen (ohne steuerfreie Sanierungserträge nach § 3a EStG)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '4989': {
        id: '4989',
        label: 'Kostenerstattungen, Rückvergütungen und Gutschriften für frühere Jahre',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'INNERGEM_LIEF',
                id: 3,
                description: 'Lieferungen ins EU-Ausland',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '5000': {
        id: '5000',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5001': {
        id: '5001',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5002': {
        id: '5002',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5003': {
        id: '5003',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5004': {
        id: '5004',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5005': {
        id: '5005',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5006': {
        id: '5006',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5007': {
        id: '5007',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5008': {
        id: '5008',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5009': {
        id: '5009',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5010': {
        id: '5010',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5011': {
        id: '5011',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5012': {
        id: '5012',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5013': {
        id: '5013',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5014': {
        id: '5014',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5015': {
        id: '5015',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5016': {
        id: '5016',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5017': {
        id: '5017',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5018': {
        id: '5018',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5019': {
        id: '5019',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5020': {
        id: '5020',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5021': {
        id: '5021',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5022': {
        id: '5022',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5023': {
        id: '5023',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5024': {
        id: '5024',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5025': {
        id: '5025',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5026': {
        id: '5026',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5027': {
        id: '5027',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5028': {
        id: '5028',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5029': {
        id: '5029',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5030': {
        id: '5030',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5031': {
        id: '5031',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5032': {
        id: '5032',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5033': {
        id: '5033',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5034': {
        id: '5034',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5035': {
        id: '5035',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5036': {
        id: '5036',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5037': {
        id: '5037',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5038': {
        id: '5038',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5039': {
        id: '5039',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5040': {
        id: '5040',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5041': {
        id: '5041',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5042': {
        id: '5042',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5043': {
        id: '5043',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5044': {
        id: '5044',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5045': {
        id: '5045',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5046': {
        id: '5046',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5047': {
        id: '5047',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5048': {
        id: '5048',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5049': {
        id: '5049',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5050': {
        id: '5050',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5051': {
        id: '5051',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5052': {
        id: '5052',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5053': {
        id: '5053',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5054': {
        id: '5054',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5055': {
        id: '5055',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5056': {
        id: '5056',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5057': {
        id: '5057',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5058': {
        id: '5058',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5059': {
        id: '5059',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5060': {
        id: '5060',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5061': {
        id: '5061',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5062': {
        id: '5062',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5063': {
        id: '5063',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5064': {
        id: '5064',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5065': {
        id: '5065',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5066': {
        id: '5066',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5067': {
        id: '5067',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5068': {
        id: '5068',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5069': {
        id: '5069',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5070': {
        id: '5070',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5071': {
        id: '5071',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5072': {
        id: '5072',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5073': {
        id: '5073',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5074': {
        id: '5074',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5075': {
        id: '5075',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5076': {
        id: '5076',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5077': {
        id: '5077',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5078': {
        id: '5078',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5079': {
        id: '5079',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5080': {
        id: '5080',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5081': {
        id: '5081',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5082': {
        id: '5082',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5083': {
        id: '5083',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5084': {
        id: '5084',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5085': {
        id: '5085',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5086': {
        id: '5086',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5087': {
        id: '5087',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5088': {
        id: '5088',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5089': {
        id: '5089',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5090': {
        id: '5090',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5091': {
        id: '5091',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5092': {
        id: '5092',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5093': {
        id: '5093',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5094': {
        id: '5094',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5095': {
        id: '5095',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5096': {
        id: '5096',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5097': {
        id: '5097',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5098': {
        id: '5098',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5099': {
        id: '5099',
        label: 'Aufwendungen für Roh-, Hilfs- und Betriebsstoffe und für bezogene Waren',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5100': {
        id: '5100',
        label: 'Einkauf Roh-, Hilfs und Betriebsstoffe',
        description: 'Kosten für Material zur Weiterverarbeitung',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5110': {
        id: '5110',
        label: 'Einkauf Roh-, Hilfs und Betriebsstoffe 7 %  Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5130': {
        id: '5130',
        label: 'Einkauf Roh-, Hilfs und Betriebsstoffe 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5200': {
        id: '5200',
        label: 'Wareneingang',
        description: 'Kosten für gekaufte Waren',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5300': {
        id: '5300',
        label: 'Wareneingang 7 % VSt',
        description: 'Kosten für gekaufte Waren mit 7 %',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5301': {
        id: '5301',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5302': {
        id: '5302',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5303': {
        id: '5303',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5304': {
        id: '5304',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5305': {
        id: '5305',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5306': {
        id: '5306',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5307': {
        id: '5307',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5308': {
        id: '5308',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5309': {
        id: '5309',
        label: 'Wareneingang 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5349': {
        id: '5349',
        label: 'Wareneingang ohne Vorsteuerabzug',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5400': {
        id: '5400',
        label: 'Wareneingang 19 % Vorsteuer',
        description: 'Kosten für gekaufte Waren mit 19 %',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5401': {
        id: '5401',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5402': {
        id: '5402',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5403': {
        id: '5403',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5404': {
        id: '5404',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5405': {
        id: '5405',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5406': {
        id: '5406',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5407': {
        id: '5407',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5408': {
        id: '5408',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5409': {
        id: '5409',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5418': {
        id: '5418',
        label: 'Wareneingang 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5425': {
        id: '5425',
        label: 'Innergemeinschaftlicher Erwerb 19 % Vorsteuer und 19 % Umsatzsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5426': {
        id: '5426',
        label: 'Innergemeinschaftlicher Erwerb 19 % Vorsteuer und 19 % Umsatzsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5427': {
        id: '5427',
        label: 'Innergemeinschaftlicher Erwerb 19 % Vorsteuer und 19 % Umsatzsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5428': {
        id: '5428',
        label: 'Innergemeinschaftlicher Erwerb 19 % Vorsteuer und 19 % Umsatzsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5429': {
        id: '5429',
        label: 'Innergemeinschaftlicher Erwerb 19 % Vorsteuer und 19 % Umsatzsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5559': {
        id: '5559',
        label: 'Steuerfreie Einfuhren',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5600': {
        id: '5600',
        label: 'NIcht abziehbare Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5610': {
        id: '5610',
        label: 'Nicht abziehbare Vorsteuer 7 %',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5660': {
        id: '5660',
        label: 'Nicht abziehbare Vorsteuer 19 %',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5700': {
        id: '5700',
        label: 'Nachlässe',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5701': {
        id: '5701',
        label: 'Nachlässe und Einkauf RHB',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5710': {
        id: '5710',
        label: 'Nachlässe 7 %  Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5714': {
        id: '5714',
        label: 'Nachlässe aus Einkauf Roh-, Hilfs- und Betriebsstoffe 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5715': {
        id: '5715',
        label: 'Nachlässe aus Einkauf Roh-, Hilfs- und Betriebsstoffe 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5720': {
        id: '5720',
        label: 'Nachlässe 19 %  Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5730': {
        id: '5730',
        label: 'Erhaltene Skonti',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5731': {
        id: '5731',
        label: 'Erhaltene Skonti 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5733': {
        id: '5733',
        label: 'Erhaltene Skonti Einkauf RHB',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5734': {
        id: '5734',
        label: 'Erhaltene Skonti Einkauf RHB 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5736': {
        id: '5736',
        label: 'Erhaltene Skonti 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5738': {
        id: '5738',
        label: 'Erhaltene Skonti Einkauf RHB 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5744': {
        id: '5744',
        label: 'Erhaltene Skonti aus Einkauf Roh-, Hilfs- und Betriebsstoffe aus steuerpflichtigem innergemeinschaftlichem Erwerb',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5745': {
        id: '5745',
        label: 'Erhaltene Skonti aus steuerpflichtigem innergemeinschaftlichem Erwerb',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5750': {
        id: '5750',
        label: 'Erhaltene Boni 7 %  Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5753': {
        id: '5753',
        label: 'Erhaltene Boni aus Einkauf RHB',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5754': {
        id: '5754',
        label: 'Erhaltene Boni aus Einkauf Roh-, Hilfs- und Betriebsstoffen 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5755': {
        id: '5755',
        label: 'Erhaltene Boni aus Einkauf Roh-, Hilfs- und Betriebsstoffen 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5760': {
        id: '5760',
        label: 'Erhaltene Boni 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5769': {
        id: '5769',
        label: 'Erhaltene Boni',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5770': {
        id: '5770',
        label: 'Erhaltene Rabatte',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5780': {
        id: '5780',
        label: 'Erhaltene Rabatte 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5783': {
        id: '5783',
        label: 'Erhaltene Rabatte auf Einkauf RHB',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5784': {
        id: '5784',
        label: 'Erhaltene Rabatte auf Einkauf Roh-, Hilfs- und Betriebsstoffen 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5785': {
        id: '5785',
        label: 'Erhaltene Rabatte auf Einkauf Roh-, Hilfs- und Betriebsstoffen 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5790': {
        id: '5790',
        label: 'Erhaltene Rabatte 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5800': {
        id: '5800',
        label: 'Bezugsnebenkosten',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5820': {
        id: '5820',
        label: 'Leergut',
        description: 'z. B. Paletten',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5840': {
        id: '5840',
        label: 'Zölle und Einfuhrabgaben',
        description:
            'Ausgaben für die Einfuhr von Waren, z. B. Zollgebühren, Bereitstellungsprovisionen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5900': {
        id: '5900',
        label: 'Fremdleistungen',
        description: 'Kosten für Subunternehmer und Externe, z. B. Werbetexter',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5901': {
        id: '5901',
        label: 'Fremdleistungen',
        description: 'Kosten für Subunternehmer und Externe, z. B. Werbetexter',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5906': {
        id: '5906',
        label: 'Fremdleistungen 19 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5908': {
        id: '5908',
        label: 'Fremdleistungen 7 % Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5920': {
        id: '5920',
        label: 'Bauleistungen eines im Inland ansässigen Unternehmers zum allgemeinen Vor- und Umsatzsteuersatz',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5923': {
        id: '5923',
        label: 'Sonstige Leistungen eines im anderen EU-Land ansässigen Unternehmers zum allgemeinen Vorsteuer- und Umsatzsteuersatz',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5925': {
        id: '5925',
        label: 'Leistungen eines im Ausland ansässigen Unternehmers zum allgemeinen Vorsteuer- und Umsatzsteuersatz',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5943': {
        id: '5943',
        label: 'Sonstige Leistungen eines im anderen EU-Land ansässigen Unternehmers ohne Vorsteuer und zum allgemeinen Umsatzsteuersatz',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5960': {
        id: '5960',
        label: 'Leistungen § 13b mit Vorsteuerabzug',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '5965': {
        id: '5965',
        label: 'Leistungen § 13b ohne Vorsteuerabzug',
        description: '',
        allowedTaxRules: [
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6000': {
        id: '6000',
        label: 'Löhne und Gehälter',
        description: 'Kosten für Löhne und Gehälter von Mitarbeitern',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6010': {
        id: '6010',
        label: 'Löhne',
        description: 'Kosten für Löhne von Mitarbeitern',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6020': {
        id: '6020',
        label: 'Gehälter',
        description: 'Kosten für Gehälter von Mitarbeitern',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6024': {
        id: '6024',
        label: 'Geschaftsführergehälter GmbH-Gesellschafter',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6027': {
        id: '6027',
        label: 'Geschäftsführergehälter',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6028': {
        id: '6028',
        label: 'Vergütungen an Mitunternehmer § 15 EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6029': {
        id: '6029',
        label: 'Tantieme Arbeitnehmer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6030': {
        id: '6030',
        label: 'Aushilfslöhne',
        description: 'Kosten für Aushilfen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6035': {
        id: '6035',
        label: 'Löhne für Minijobs',
        description: 'Kosten für Minijobber',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6036': {
        id: '6036',
        label: 'Pauschale Steuern Minijobber',
        description: 'Kosten für die pauschale Besteuerung von Minijobbern',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6040': {
        id: '6040',
        label: 'Pauschale Steuer für Aushilfen',
        description: 'Kosten für die pauschale Besteuerung von Aushilfen',
        allowedTaxRules: [
            {
                name: 'NICHT_STEUERBAR_EXPENSE',
                id: 16,
                description: 'z.B. Privateinlagen oder Eigenverbrauch',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6045': {
        id: '6045',
        label: 'Bedienungsgelder',
        description: 'Trinkgelder für Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6050': {
        id: '6050',
        label: 'Ehegattengehalt',
        description: 'Kosten für Gehälter an verheiratete Lebenspartner',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6060': {
        id: '6060',
        label: 'Freiwiliige soziale Aufwendungen lohnsteuerpflichtig',
        description:
            'Freiwillige lohnsteuerpflichtige Aufwendungen an Arbeitnehmer, z. B. wenn der monatliche Betrag vom Gutschein die LSt-freie Grenze von 50 € übersteigt',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6066': {
        id: '6066',
        label: 'Freiwillige Zuwendungen an Minijobber',
        description: 'Freiwillige Aufwendungen an Minijobber',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6069': {
        id: '6069',
        label: 'Pauschale Steuer aus sonstige Bezüge',
        description:
            'Kosten für die pauschale Besteuerung von sonstigen Bezügen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6070': {
        id: '6070',
        label: 'Krankengeldzuschüsse',
        description: 'Zuschüsse der Krankenkassen für Krankengelder',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6071': {
        id: '6071',
        label: 'Sachzuwendungen und Dienstleistungen Minijob',
        description:
            'z. B. Geschenke an Minijobber, die die SV- und LSt-Grenzen überschreiten und deswegen mit 30 % pauschal besteuert wurden',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6072': {
        id: '6072',
        label: 'Sachzuwendungen und Dienstleistungen an Arbeitnehmer',
        description:
            'z. B. Geschenke an Arbeitnehmer, die die SV- und LSt-Grenzen überschreiten und deswegen mit 30 % pauschal besteuert wurden',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6075': {
        id: '6075',
        label: 'Zuschüsse Agenturen für Arbeit',
        description:
            'Förderungen der Agentur für Arbeit für die Aufnahme von z. B. älteren oder behinderten Arbeitnehmern',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6080': {
        id: '6080',
        label: 'Vermögenswirksame Leistungen',
        description: 'Aufwendungen für VWL-Verträge der Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6090': {
        id: '6090',
        label: 'Fahrtkostenerstattung Whg./Arbeitsstätte',
        description:
            'Erstattung der Kosten an Arbeitnehmer für Fahrten zwischen Wohn- und Arbeitsstätte',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6110': {
        id: '6110',
        label: 'Gesetzliche Sozialaufwendungen',
        description: 'Beiträge zur Krankenkasse',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6120': {
        id: '6120',
        label: 'Beiträge zur Berufsgenossenschaft',
        description: 'Beiträge zur Berufsgenossenschaft (BG)',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6130': {
        id: '6130',
        label: 'Freiwillige soziale Aufwendungen lohnsteuerfrei',
        description: 'Freiwillige lohnsteuerfreie Aufwendungen an Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6140': {
        id: '6140',
        label: 'Aufwendungen für Altersversorgung',
        description: 'Aufwendungen für Altersvorsorgeverträge der Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6147': {
        id: '6147',
        label: 'Pauschale Steuer für versicherungen',
        description:
            'Pauschale Steuer auf Versicherungsverträge der Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6148': {
        id: '6148',
        label: 'Aufwendungen Altersversorgung für Mitunternehmer § 15 EStg',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6149': {
        id: '6149',
        label: 'Aufwendungen Altersversorgung Gesellschafter-Geschäftsführer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6150': {
        id: '6150',
        label: 'Versorgungskassen',
        description: 'Aufwendungen an die Versorgungskasse',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6160': {
        id: '6160',
        label: 'Aufwendungen für Unterstützung',
        description: 'Aufwendungen für Unterstützungen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6170': {
        id: '6170',
        label: 'Sonstige soziale Abgaben',
        description:
            'Sonstige soziale Abgaben an Arbeitnehmer, die nicht anderen Konten zugeordnet werden können',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6171': {
        id: '6171',
        label: 'Soziale Abgaben für Minijobber',
        description: 'Aufwendungen für die sozialen Abgaben an Minijobber',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6200': {
        id: '6200',
        label: 'Abschreibungen immaterielle VermG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6201': {
        id: '6201',
        label: 'Abschreibungen auf selbst geschaffene immaterielle Vermögensgegenstände',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6205': {
        id: '6205',
        label: 'Abschreibung Geschäfts- oder Firmenwert',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6220': {
        id: '6220',
        label: 'Abschreibungen auf Sachanlagen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6221': {
        id: '6221',
        label: 'Abschreibungen auf Gebäude',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6222': {
        id: '6222',
        label: 'Abschreibungen auf KFZ',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6241': {
        id: '6241',
        label: 'Sonderabschreibungen § 7g Abs.5 EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6242': {
        id: '6242',
        label: 'Sonderabschreibungen KFZ § 7g Abs. 5 EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6245': {
        id: '6245',
        label: 'Sonderabschreibungen § 7b EStG (Mietwohnungsneubau)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6250': {
        id: '6250',
        label: 'Kaufleasing',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6260': {
        id: '6260',
        label: 'Sofortabschreibung GWG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6262': {
        id: '6262',
        label: 'Abschreibungen auf aktivierte GWG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6264': {
        id: '6264',
        label: 'Abschreibungen auf WG Sammelposten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6280': {
        id: '6280',
        label: 'Forderungsverluste',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6281': {
        id: '6281',
        label: 'Forderungsverluste 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6286': {
        id: '6286',
        label: 'Forderungsverluste 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6300': {
        id: '6300',
        label: 'sonstige betriebliche Aufwendungen',
        description:
            'Kosten für sonstige Anschaffungen, die sich keiner Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6301': {
        id: '6301',
        label: 'sonstige betriebliche Aufwendungen',
        description:
            'Kosten für sonstige Anschaffungen, die sich keiner Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6302': {
        id: '6302',
        label: 'Interimskonto für Aufwendungen in einem anderen Land, bei denen eine Vorsteuervergütung möglich ist',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6303': {
        id: '6303',
        label: 'Fremdleistungen und Fremdarbeiten',
        description:
            'Fremdleistungen, die dem allgemeinen Geschäftsbetrieb dienen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6304': {
        id: '6304',
        label: 'Sonstige betriebliche und regelmäßige Aufwendungen',
        description:
            'Aufwendungen, die regelmäßig dem allgemeinen Geschäftsbetrieb dienen und sich keiner anderen Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6305': {
        id: '6305',
        label: 'Raumkosten',
        description:
            'Sonstige Kosten für betriebliche Räume, die sich keiner anderen Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6310': {
        id: '6310',
        label: 'Miete, unbewegliche Wirtschaftsgüter',
        description: 'Kosten für die Miete oder Pacht von Räumlichkeiten',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6312': {
        id: '6312',
        label: 'Miete/Aufwendungen für doppelte Haushaltsführung Unternehmer',
        description: 'Aufwendungen für eine zweite Wohnung für den Unternehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6315': {
        id: '6315',
        label: 'Pacht, unbewegliche Wirtschaftsgüter',
        description: 'z.B. die monatlich gezahlte Pacht für ein Grundstück',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6316': {
        id: '6316',
        label: 'Leasing, unbewegliche Wirtschaftsgüter',
        description:
            'Leasingaufwendungen für unbewegliche Gegenstände (z.B. fest verankerte Maschinen)',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6317': {
        id: '6317',
        label: 'Aufwendungen für unbewegliche Wirtschaftsgüter (GewSt hinzuzurechnen)',
        description: 'Sonstige Aufwendungen für unbewegliche Wirtschaftsgüter',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6318': {
        id: '6318',
        label: 'Miet- und Pachtnebenkosten',
        description: 'Nebenkosten für gemietete oder gepachtete Objekte',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6320': {
        id: '6320',
        label: 'Heizung',
        description: 'Aufwendungen für Heizkosten',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6325': {
        id: '6325',
        label: 'Gas, Strom, Wasser',
        description: 'Nebenkosten, z.B. die E-Werk-Rechnung',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6330': {
        id: '6330',
        label: 'Reinigung',
        description: 'Kosten für Reinigungsmittel',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6335': {
        id: '6335',
        label: 'Instandhaltung betrieblicher Räume',
        description: 'z.B. Renovierungsarbeiten',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6340': {
        id: '6340',
        label: 'Abgaben betrieblich genutzter Grundbesitz',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6345': {
        id: '6345',
        label: 'Sonstige Raumkosten',
        description:
            'Sonstige Kosten für betriebliche Räume, die sich keiner Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6348': {
        id: '6348',
        label: 'Aufwendungen für ein häusliches Arbeitszimmer (Abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6349': {
        id: '6349',
        label: 'Aufwendungen für ein häusliches Arbeitszimmer (nicht abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6350': {
        id: '6350',
        label: 'Grundstücksaufwendungen, betrieblich',
        description: 'Sonstige Kosten für das betriebliche Grundstück',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6352': {
        id: '6352',
        label: 'Sonstige Grundstücksaufwendungen neutral',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6390': {
        id: '6390',
        label: 'Zuwendungen, Spenden steuerlich nicht abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6391': {
        id: '6391',
        label: 'Zuwendungen, Spenden für wissenschaftliche und kulturelle Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6392': {
        id: '6392',
        label: 'Zuwendungen, Spenden für mildtätige Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6393': {
        id: '6393',
        label: 'Zuwendungen, Spenden für kirchliche, religiöse und gemeinnützige Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6394': {
        id: '6394',
        label: 'Zuwendungen, Spenden an politische Partei',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6395': {
        id: '6395',
        label: 'Zuwendungen, Spenden an Stiftungen gemeinnützige Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6397': {
        id: '6397',
        label: 'Zuwendungen, Spenden an Stiftungen kirchliche, religiöse und gemeinnützige Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6398': {
        id: '6398',
        label: 'Zuwendungen, Spenden an Stiftungen wissenschaftliche, mildtätige und kulturelle Zwecke',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6400': {
        id: '6400',
        label: 'Versicherung',
        description: 'Kosten für betriebliche Versicherungen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6405': {
        id: '6405',
        label: 'Versicherung für Gebäude',
        description: 'Kosten für die betriebliche Versicherung von Gebäuden',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6410': {
        id: '6410',
        label: 'Prämie Rückdeckung für Versorgungsleistungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6420': {
        id: '6420',
        label: 'Beiträge',
        description: 'Beitragsgebühren z.B. für Kammergebühren',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6430': {
        id: '6430',
        label: 'Sonstige Abgaben',
        description: 'Sonstige Abgaben',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6436': {
        id: '6436',
        label: 'Abzugsf. Verspätungszuschlag/ Zwangsgeld',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6437': {
        id: '6437',
        label: 'Nicht abzugsfähige Verspätungszuschläge/ Zwangsgelder',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6440': {
        id: '6440',
        label: 'Ausgleichsabgabe SchwerbehindertenG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6450': {
        id: '6450',
        label: 'Reparatur und Instandhaltungen von Bauten',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6460': {
        id: '6460',
        label: 'Reparatur und Instandhaltungen Anlagen u. Maschinen',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6470': {
        id: '6470',
        label: 'Reparatur und Instandhaltung Anlagen, Betriebs- und Geschäftsausstattung',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6475': {
        id: '6475',
        label: 'Zuführung zu Aufwandsrückstellungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6490': {
        id: '6490',
        label: 'Sonstige Reparaturen/Instandhaltung',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6495': {
        id: '6495',
        label: 'Wartungskosten für Hard- und Software',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6498': {
        id: '6498',
        label: 'Mietleasing bewegliche WG technische Anlagen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6500': {
        id: '6500',
        label: 'Fahrzeugkosten',
        description: 'Sonstige Kosten im Zusammenhang mit einem Fahrzeug',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6520': {
        id: '6520',
        label: 'KFZ-Versicherung',
        description: 'Kosten für die Versicherung von Fahrzeugen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6530': {
        id: '6530',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6531': {
        id: '6531',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6532': {
        id: '6532',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6533': {
        id: '6533',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6534': {
        id: '6534',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6535': {
        id: '6535',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6536': {
        id: '6536',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6537': {
        id: '6537',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6538': {
        id: '6538',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6539': {
        id: '6539',
        label: 'Laufende KFZ-Betriebskosten',
        description:
            'Kosten für Kraftstoffe und die Wagenpflege, z.B. Waschanlage',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6540': {
        id: '6540',
        label: 'KFZ-Reparaturen',
        description:
            'Kosten für Reparatur eines Fahrzeugs, Kundenservices etc.',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6550': {
        id: '6550',
        label: 'Garagenmieten',
        description: 'Kosten für Garagen und Parkplätze',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6560': {
        id: '6560',
        label: 'Mietleasing Kfz',
        description: 'Gebühren für Leasingfahrzeuge',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6565': {
        id: '6565',
        label: 'Mietleasingaufw. für Elektrofzg. die gewerbesteuerlich hinzuzurechnen sind',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6570': {
        id: '6570',
        label: 'Sonstige Kfz-Kosten',
        description: 'Sonstige Kosten im Zusammenhang mit einem Fahrzeug',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6580': {
        id: '6580',
        label: 'Mautgebühren',
        description: 'z.B. Vignette, Autobahngebühren',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6590': {
        id: '6590',
        label: 'Kfz-Kosten für betrieblich genutzte zum Privatvermögen gehörende Kraftfahrzeuge',
        description: 'Gebühren für Mietwagen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6595': {
        id: '6595',
        label: 'Fremdfahrzeugkosten',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6600': {
        id: '6600',
        label: 'Werbekosten',
        description: 'Kosten für Werbeschaltungen, Messen und Werbemittel',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6605': {
        id: '6605',
        label: 'Streuartikel',
        description: 'Aufwendungen für die Kundenpflege',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6610': {
        id: '6610',
        label: 'Geschenke abzugsfähig ohne § 37b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6611': {
        id: '6611',
        label: 'Geschenke abzugsfähig mit § 37b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6612': {
        id: '6612',
        label: 'Pauschale Steuern Geschenke/Zugaben abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6620': {
        id: '6620',
        label: 'Geschenke nicht abzugsfähig ohne § 37b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6621': {
        id: '6621',
        label: 'Geschenke nicht abzugsfähig mit § 37b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6622': {
        id: '6622',
        label: 'Pauschale Steuern für Zuwendungen nicht abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6625': {
        id: '6625',
        label: 'Geschenke ausschließlich betrieblich genutzt',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6629': {
        id: '6629',
        label: 'Zugaben mit § 37b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6630': {
        id: '6630',
        label: 'Repräsentationskosten',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6641': {
        id: '6641',
        label: 'Sonstige eingeschränkt abziehbare Betriebsausgaben (abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6642': {
        id: '6642',
        label: 'Sonstige eingeschränkt abziehbare Betriebsausgaben (nicht abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6643': {
        id: '6643',
        label: 'Aufmerksamkeiten',
        description: 'z.B. Getränke, Häppchen etc.',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6645': {
        id: '6645',
        label: 'Nicht abzugsfähige Betriebsausgaben',
        description: 'z.B. Verwarnungsgelder',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6650': {
        id: '6650',
        label: 'Reisekosten Arbeitnehmer',
        description:
            'Sonstige Kosten für betrieblich veranlasste Reisen der Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6660': {
        id: '6660',
        label: 'Reisekosten AN Übernachtungsaufwand',
        description:
            'Übernachtungsaufwendungen für betrieblich veranlasste Reisen der Arbeitnehmer, z.B Hotelkosten',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6663': {
        id: '6663',
        label: 'Reisekosten Arbeitnehmer Fahrtkosten',
        description:
            'Fahrtkosten für betrieblich veranlasste Reisen der Arbeitnehmer z.B. Taxi',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6664': {
        id: '6664',
        label: 'Reisekosten AN Verpflegungsmehraufwand',
        description:
            'Spesen für zusätzlich entstandene Kosten auf Geschäftsreisen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6668': {
        id: '6668',
        label: 'Kilometergelderstattung Arbeitnehmer',
        description:
            'Erstattung der gefahrenen Kilometer (mit dem privaten PKW) der Arbeitnehmer',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6670': {
        id: '6670',
        label: 'Reisekosten Unternehmer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6672': {
        id: '6672',
        label: 'Reisekosten Unternehmer (nicht abziehbarer Anteil)',
        description: 'nicht abziehbare Reisekosten des Unternehmers',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6673': {
        id: '6673',
        label: 'Reisekosten Unternehmer Fahrtkosten',
        description: 'Kosten für betriebliche Fahrten, Taxifahrten etc.',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6674': {
        id: '6674',
        label: 'Reisekosten Unternehmer Verpflegungsmehraufwand',
        description:
            'Spesen für zusätzlich entstandene Kosten auf Geschäftsreisen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6680': {
        id: '6680',
        label: 'Reisekosten Unternehmer Übernachtungsaufwand und Reisenebenkosten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6688': {
        id: '6688',
        label: 'Fahrten zwischen Wohn und Betriebsstätte und Familienheimfahrten (abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6689': {
        id: '6689',
        label: 'Fahrten zwischen Wohn und Betriebsstätte und Familienheimfahrten (nicht abziehbarer Anteil)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6690': {
        id: '6690',
        label: 'Fahrten zwischen Wohn und Betriebsstätte und Familienheimfahrten (Haben)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6691': {
        id: '6691',
        label: 'Verpflegungsmehraufwendungen im Rahmen der doppelten Haushaltsführung Unternehmer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6700': {
        id: '6700',
        label: 'Kosten Warenabgabe',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6710': {
        id: '6710',
        label: 'Verpackungsmaterial',
        description: 'Aufwendungen für die Verpackung z.B. Kartonagen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6740': {
        id: '6740',
        label: 'Ausgangsfrachten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6760': {
        id: '6760',
        label: 'Transportversicherungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6770': {
        id: '6770',
        label: 'Verkaufsprovisionen',
        description: 'Provisionszahlungen für externe Vertriebler',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6780': {
        id: '6780',
        label: 'Fremdarbeiten (Vertrieb)',
        description: 'Aufwendungen für externe Vertriebler',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6790': {
        id: '6790',
        label: 'Aufwand für Gewährleistungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6800': {
        id: '6800',
        label: 'Porto',
        description: 'z.B. Briefmarken oder Paketscheine',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6805': {
        id: '6805',
        label: 'Telefon',
        description: 'Kosten für den Festnetzanschluss oder Handyvertrag',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6810': {
        id: '6810',
        label: 'Telefax und Internetkosten',
        description: 'Kosten für den Internetzugang',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6815': {
        id: '6815',
        label: 'Bürobedarf',
        description: 'z.B. Papier, Stifte und Blöcke',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6820': {
        id: '6820',
        label: 'Zeitschriften, Bücher (Fachliteratur)',
        description: 'z.B. Fachzeitschriften oder Lektüren',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6821': {
        id: '6821',
        label: 'Fortbildungskosten',
        description: 'Kosten für Weiterbildungsmaßnahmen, z.B. Kursgebühren',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6822': {
        id: '6822',
        label: 'Freiwillige Sozialleistungen',
        description: 'Sozialleistungen, die keinen Arbeitslohn darstellen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6824': {
        id: '6824',
        label: 'Haftungsvergütung an Mitunternehmer § 15 EStG (mit Sonderbetriebseinnahme korrespondierend)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6825': {
        id: '6825',
        label: 'Rechts- und Beratungskosten',
        description: 'Kosten für Rechtsberatung',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6827': {
        id: '6827',
        label: 'Abschluss- und Prüfungskosten',
        description:
            'Kosten für Abschlüsse, Prüfungen und Steuerberatung im Allgemeinen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6830': {
        id: '6830',
        label: 'Buchführungskosten',
        description:
            'Kosten für die laufende Buchhaltung, z.B. Kosten vom Buchhaltungsbüro',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6835': {
        id: '6835',
        label: 'Mieten für Einrichtungen bewegliche WG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6836': {
        id: '6836',
        label: 'Pacht (bewegliche Wirtschaftsgüter)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6837': {
        id: '6837',
        label: 'laufende Gebühren für Lizenzen',
        description: 'z.B. Software-Abonnements wie sevdesk',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6838': {
        id: '6838',
        label: 'Aufwendungen für bewegliche Wirtschaftsgüter, GewStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6840': {
        id: '6840',
        label: 'Mietleasing bewegliche WG Betriebsausstattung',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6845': {
        id: '6845',
        label: 'Werkzeuge und Kleingeräte',
        description: 'Kosten für kleinere Anschaffungen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6850': {
        id: '6850',
        label: 'Sonstiger Betriebsbedarf',
        description:
            'Kosten für sonstige Anschaffungen, die sich keiner Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6851': {
        id: '6851',
        label: 'Sonstiger Betriebsbedarf',
        description:
            'Kosten für sonstige Anschaffungen, die sich keiner Kategorie zuordnen lassen',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6854': {
        id: '6854',
        label: 'Genossenschaftliche Rückvergütung an Mitunternehmer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6855': {
        id: '6855',
        label: 'Nebenkosten des Geldverkehrs',
        description: 'z.B. Kontogebühren und Gebühren für Kreditkarten',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6856': {
        id: '6856',
        label: 'Aufwendungen aus Anteilen an Kapitalgesellschaften §§ 3 Nr. 40 und 3c EStG bzw. § 8b Abs. 1 und 4 KStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6857': {
        id: '6857',
        label: 'Veräußerungskosten z.T. nicht abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6858': {
        id: '6858',
        label: 'Veräußerungskosten § 3 Nr. 40 EStG bzw. § 8b Abs. 3 KStG (bei Veräußerungsverlust)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6859': {
        id: '6859',
        label: 'Aufwand Abraum-/Abfallbeseitigung',
        description: 'Kosten für die Müllentsorgung',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6860': {
        id: '6860',
        label: 'Nicht abziehbare Vorsteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6865': {
        id: '6865',
        label: 'Nicht abziehbare Vorsteuer 7 %',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6871': {
        id: '6871',
        label: 'Nicht abziehbare Vorsteuer 19 %',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6875': {
        id: '6875',
        label: 'Nicht abziehbare Aufsichtsratsvergütungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6880': {
        id: '6880',
        label: 'Aufwendungen aus Währungsumrechnung',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6885': {
        id: '6885',
        label: 'Erlöse aus Verkäufen Sachanlagenvermögen 19 % USt (bei Buchverlust)',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6889': {
        id: '6889',
        label: 'Erlöse Sachanlagenverkäufe Buchverlust',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6890': {
        id: '6890',
        label: 'Erlöse Verkäufe immaterielle Vermögensgegenstände, BV',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6895': {
        id: '6895',
        label: 'Abgänge Sachanlagen Restbuchwert bei BV',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6896': {
        id: '6896',
        label: 'Abgang immaterielle Vermögensgegenstände RBW, BV',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6900': {
        id: '6900',
        label: 'Verluste aus Anlagenabgang',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6907': {
        id: '6907',
        label: 'Abgang von WG des Umlaufvermögens § 4 Abs.3 Satz EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6908': {
        id: '6908',
        label: 'Abgang von WG des Umlaufvermögens § 3 Nr. 40 EStG bzw. § 8b Abs. 3 KStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6910': {
        id: '6910',
        label: 'Abschreibungen auf Umlaufvermögen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6920': {
        id: '6920',
        label: 'Einstellungen in die Pauschalwertberichtigung auf Forderungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6923': {
        id: '6923',
        label: 'Einstellung in die Einzelwertberichtigung auf Forderungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6930': {
        id: '6930',
        label: 'Forderungsverluste',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6931': {
        id: '6931',
        label: 'Forderungsverlust 7 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6933': {
        id: '6933',
        label: 'Forderungsverluste EU-Lieferungen 7 %',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['SEVEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6936': {
        id: '6936',
        label: 'Forderungsverluste 19 % USt',
        description: '',
        allowedTaxRules: [
            {
                name: 'USTPFL_UMS_EINN',
                id: 1,
                description: 'Umsatzsteuerpflichtige Umsätze',
                taxRates: ['NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '6960': {
        id: '6960',
        label: 'Periodenfremde Aufwendungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6967': {
        id: '6967',
        label: 'Sonstige Aufwendungen, betriebsfremd und regelmäßig',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6968': {
        id: '6968',
        label: 'Sonstige nicht abziehbare Aufwendungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6969': {
        id: '6969',
        label: 'Sonstige Aufwendungen unregelmäßig',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '6992': {
        id: '6992',
        label: 'Verwaltungskosten',
        description: '',
        allowedTaxRules: [
            {
                name: 'INNERGEM_ERWERB',
                id: 8,
                description: 'Innergemeinschaftliche Erwerbe',
                taxRates: ['ZERO'],
            },
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7100': {
        id: '7100',
        label: 'Sonstige Zinsen und ähnliche Erträge',
        description: '',
        allowedTaxRules: [
            {
                name: 'STFREIE_UMS_P4',
                id: 4,
                description: 'Steuerfreie Umsätze §4 UStG',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['REVENUE'],
    },
    '7200': {
        id: '7200',
        label: 'Abschreibungen auf Finanzanlagen (dauerhaft)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7201': {
        id: '7201',
        label: 'Abschreibungen aus Finanzanlagen (nicht dauerhaft)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7204': {
        id: '7204',
        label: 'Abschreibungen auf Finanzanlagen § 3 Nr. 40 EStG bzw. § 8b Abs. 3 KStG (dauerhaft)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7207': {
        id: '7207',
        label: 'Abschreibungen auf Finanzanlagen - verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7208': {
        id: '7208',
        label: 'Aufwendungen auf Grund von Verlustanteilen an gewerblichen und selbständigen Mitunternehmerschaften, § 8 GewStG bzw. § 18 EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7210': {
        id: '7210',
        label: 'Abschreibungen Wertpapiere des Umlaufvermögens',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7214': {
        id: '7214',
        label: 'Abschreibungen Wertpapiere Umlaufvermögens z.T. nicht abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7217': {
        id: '7217',
        label: 'Abschreibungen auf Wertpapiere des Umlaufvermögens, verb. UN',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7250': {
        id: '7250',
        label: 'Abschreibungen auf Finanzanlagen auf Grund § 6b EStG-Rücklage',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7255': {
        id: '7255',
        label: 'Abschreibungen auf Finanzanlagen auf Grund § 6b EStG-Rücklage, § 3 Nr. 40 EStG bzw. § 8b Abs. 3 KStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7300': {
        id: '7300',
        label: 'Zinsen und ähnliche Aufwendungen',
        description: 'Sonstige Zinsaufwendungen',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7302': {
        id: '7302',
        label: 'Nicht abzugsfähige andere Nebenleistungen § 4/5b EStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7303': {
        id: '7303',
        label: 'Abzugsfähige andere Nebenleistungen zu Steuern',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7304': {
        id: '7304',
        label: 'Nicht abzugsfähige andere Nebenleistungen z. Steuern',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7305': {
        id: '7305',
        label: 'Zinsaufwendungen § 233a AO abzugsfähig',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7306': {
        id: '7306',
        label: 'Zinsaufwendungen §§ 234 bis 237 AU nicht abzugsfähig',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7308': {
        id: '7308',
        label: 'Zinsaufwendungen § 233a AO nicht abzugsfähig',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7309': {
        id: '7309',
        label: 'Zinsaufwendungen an verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7310': {
        id: '7310',
        label: 'Zinsaufwendungen für kurzfristige Verbindlichkeiten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7311': {
        id: '7311',
        label: 'Zinsaufwendungen §§ 234 bis 237 AO abzugsfähig',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7313': {
        id: '7313',
        label: 'Nicht abzugsfähige Schuldzinsen nach § 4 Abs. 4a EStG (Hinzurechnungsbetrag)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7316': {
        id: '7316',
        label: 'Zinsen für Gesellschafterdarlehen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7317': {
        id: '7317',
        label: 'Zinsen an Gesellschafter mit einer Beteiligung von mehr als 25 % bzw. diese nahestehenden Personen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7318': {
        id: '7318',
        label: 'Zinsen auf Kontokorrentkonten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7319': {
        id: '7319',
        label: 'Zinsaufwendungen für kurzfristige Verbindlichkeiten an verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7320': {
        id: '7320',
        label: 'Zinsaufwendungen für langfristige Verbindlichkeiten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7323': {
        id: '7323',
        label: 'Abschreibungen auf ein Agio oder Disagio/Damnum zur Finanzierung',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7324': {
        id: '7324',
        label: 'Abschreibungen auf ein Agio oder Disagio/Damnum zur Finanzierung des Anlagevermögens',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7325': {
        id: '7325',
        label: 'Zinsen für Gebäude im Betriebsvermögen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7326': {
        id: '7326',
        label: 'Zinsen zur Finanzierung Anlagevermögen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7327': {
        id: '7327',
        label: 'Renten und dauernde Lasten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7328': {
        id: '7328',
        label: 'Zinsaufwendungen für Kapitalüberlassung durch Mitunternehmer § 15 EstG (mit Sonderbetriebseinnahme korrespondierend)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7329': {
        id: '7329',
        label: 'Zinsaufwendungen für langfristige Verbindlichkeiten an verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7330': {
        id: '7330',
        label: 'Zinsähnliche Aufwendungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7339': {
        id: '7339',
        label: 'Zinsähnliche Aufwendungen an verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7340': {
        id: '7340',
        label: 'Diskontaufwendungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7349': {
        id: '7349',
        label: 'Diskontaufwendungen an verbundene Unternehmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7350': {
        id: '7350',
        label: 'Zinsen und ähnliche Aufwendungen zu Teil nicht abziehbar',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7351': {
        id: '7351',
        label: 'Zinsen und ähnliche Aufwendungen an verbundene Unternehmen §§ 3 Nr. 40 und 3c EStG bzw. § 8b Abs. 1 KStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7355': {
        id: '7355',
        label: 'Kreditprovisionen und Verwaltungskostenbeiträge',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7360': {
        id: '7360',
        label: 'Zinsanteil der Zuführungen zu Pensionsrückstellungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7361': {
        id: '7361',
        label: 'Zinsaufwendungen aus der Abzinsung von Verbindlichkeiten',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7362': {
        id: '7362',
        label: 'Zinsaufwendungen aus der Abzinsung von Rückstellungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7363': {
        id: '7363',
        label: 'Zinsaufwendungen aus der Abzinsung von Pensionsrückstellungen und ähnlichen/vergleichbaren Verpflichtungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7364': {
        id: '7364',
        label: 'Zinsaufwendungen aus der Abzinsung von Pensionsrückstellungen und ähnlichen/vergleichbaren Verpflichtungen zur Verrechnung nach § 246 Abs. 2 HGB',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7365': {
        id: '7365',
        label: 'Aufwendungen aus Vermögensgegenständen zur Verrechnung nach § 246 Abs. 2 HGB',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7366': {
        id: '7366',
        label: 'Steuerlich nicht abzugsfähige Zinsaufwendungen aus der Abzinsung von Rückstellungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7390': {
        id: '7390',
        label: 'Aufwendungen aus Verlustübernahme',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7392': {
        id: '7392',
        label: 'Abgeführte Gewinne auf Grund einer Gewinngemeinschaft',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7394': {
        id: '7394',
        label: 'Abgeführte Gewinne auf Grund eines Gewinn- oder Teilgewinnabführungsvertrags',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7399': {
        id: '7399',
        label: 'Abgeführte Gewinnanteile (Soll) / ausgeglichene Verlustanteile (Haben) bei typisch stiller Beteiligung § 8 GewStG',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7500': {
        id: '7500',
        label: 'Sonstige betriebliche Aufwendungen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7551': {
        id: '7551',
        label: 'Verluste durch Verschmelzung und Umwandlung',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7552': {
        id: '7552',
        label: 'Verluste durch außergewöhnliche Schadensfälle (nur Bilanzierer)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7553': {
        id: '7553',
        label: 'Aufwendungen für Restrukturierungs- und Sanierungsmaßnahmen',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
            {
                name: 'REV_CHARGE_13B_MIT_VORST_ABZUG_0',
                id: 12,
                description:
                    'Reverse Charge gem. §13b Abs. 2 UStG mit Vorsteuerabzug 0% (19%) z.B. Dienstleistungen aus dem Drittland, Bauleistungen',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_OHNE_VORST_ABZUG_0',
                id: 13,
                description:
                    'Reverse Charge gem. §13b UStG ohne Vorsteuerabzug 0% (19%) z.B. Kleinunternehmer, Versicherungsvertreter, Ärzte',
                taxRates: ['ZERO'],
            },
            {
                name: 'REV_CHARGE_13B_EU_0',
                id: 14,
                description:
                    'Reverse Charge gem. §13b Abs. 1 EU Umsätze 0% (19%) z.B. Dienstleistung aus den EU Staaten',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7554': {
        id: '7554',
        label: 'Verluste aus der Veräußerung oder der Aufgabe von Geschäftsaktivitäten nach Steuern',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7560': {
        id: '7560',
        label: 'Aufwendungen aus der Anwendung von Übergangsvorschriften',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7561': {
        id: '7561',
        label: 'Aufwendungen aus der Anwendung von Übergangsvorschriften (Pensionsrückstellungen)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7563': {
        id: '7563',
        label: 'Aufwendungen aus der Anwendung von Übergangsvorschriften (latente Steuern)',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '7639': {
        id: '7639',
        label: 'Anrechnung / Abzug ausländische Quellensteuer',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '9008': {
        id: '9008',
        label: 'Saldenvorträge Debitoren',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
    '9009': {
        id: '9009',
        label: 'Saldenvorträge Kreditoren',
        description: '',
        allowedTaxRules: [
            {
                name: 'VORST_ABZUGSF_AUFW',
                id: 9,
                description: 'Vorsteuerabziehbare Aufwendungen',
                taxRates: ['ZERO', 'SEVEN', 'NINETEEN'],
            },
        ],
        allowedReceiptTypes: ['EXPENSE'],
    },
}
